import cookie from 'js-cookie'
import { setup } from 'axios-cache-adapter'

const baseDomain = location.hostname.split('.').slice(-2).join('.')
const apiDomain = import.meta.env.VITE_API_DOMAIN ?? `api.${baseDomain}`

const token = cookie.get('EWS_AUTH_KEY')

const api = setup({
  baseURL: `https://${apiDomain}`,
  cache: {
    maxAge: 5 * 1000, // 5 second default
    debug: false,
    readHeaders: false,
    exclude: {
      query: false
    }
  },
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  },
  timeout: 10000
})

export default api
